import { IFilter } from '../../types/advancedFilters';
import { LivingConditionsContainer } from '../../containers/advancedFilters/LivingConditionsContainer';

export const livingConditions: IFilter = {
  component: LivingConditionsContainer,
};
